import type { FC } from "preact/compat";
import { cva } from "class-variance-authority";
import type { IconButtonProps } from "./interfaces";
import cn from "classnames";

export const buttonVariants = cva(
    "rounded-full fill-current outline-none disabled:focus:ring-none disabled:text-gray-400 disabled:hover:border-gray-200 disabled:hover:text-gray-400",
    {
        variants: {
            variant: {
                primary:
                    "hover:border-sky-300 hover:text-sky-500 focus:ring focus:ring-sky-300",
                danger: "hover:border-red-300 hover:text-red-500 focus:ring focus:ring-red-300",
            },
        },
        defaultVariants: {
            variant: "primary",
        },
    },
);

const IconButton: FC<IconButtonProps> = ({
    title,
    onClick,
    children,
    className,
    disabled,
    flat,
    size = "md",
    variant,
    ...props
}) => (
    <button
        type="button"
        title={title}
        onClick={onClick}
        disabled={disabled}
        className={cn(
            buttonVariants({ variant, className }),
            !flat && "border border-gray-300 bg-white",
            !flat && size === "md" && "p-2",
            !flat && size === "sm" && "p-1",
        )}
        {...props}
    >
        {children}
    </button>
);

export default IconButton;
